export default "__VITE_ASSET__bc068894__"